// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3wful","info":"PatientInfo_info__2hgxk"};